import useMediaQuery from '@mui/material/useMediaQuery';
import { InstagramCarrousel } from 'blocks/Carrousel';
import Inspiration from 'blocks/Inspiration/Inspiration';
import JoinNow from 'blocks/JoinNow/JoinNow';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import SearchBar from 'blocks/search-bar';
import TopPicks from 'blocks/TopPicks/TopPicks';
import { type ContentType } from 'components/Carrousel';
import {
  breakpoints,
  navigationPaths,
  PAGE_INVALIDATION_INTERVAL,
} from 'data/constants';
import type { GetStaticProps, NextPage } from 'next';
import HomePageService from 'services/HomePageService/HomePageService';
import PageService from 'services/PageService/PageService';
import { IGenericPage } from 'types/interfaces';
import { HotelTopPicksType, InspirationType } from 'types/types';

interface IOurHotelsPage extends IGenericPage {
  hotels: HotelTopPicksType[];
  inspirations: InspirationType[];
  instagram: ContentType[];
}

const OurHotels: NextPage<IOurHotelsPage> = ({
  globalLayoutProps,
  hotels,
  inspirations,
  instagram,
}) => {
  const isMobile = useMediaQuery(`(max-width:${breakpoints.sm})`);
  return (
    <GlobalLayout {...globalLayoutProps}>
      <SearchBar inspirations={inspirations} initialSearchValue=""/>
      <TopPicks ourHotels={hotels} />
      <div className="container">
        <Inspiration inspirations={inspirations} />
        <JoinNow />
      </div>
      <div className="outOfBounds">
        <InstagramCarrousel instagramData={instagram} />
      </div>
    </GlobalLayout>
  );
};

export default OurHotels;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.OUR_HOTELS,
  });

  const hotels = await PageService.getTopPickPageProps();
  const inspirations = await PageService.getInspirationsPage();
  const instagram = await HomePageService.getInstagramImages().then(data =>
    data.map(item => {
      return {
        id: item.id,
        image: item.url.replace(/^[^.]*/, 'https://scontent-lhr8-1'),
        url: item.permalink,
      };
    })
  );
  return {
    props: {
      ...genericPageProps,
      hotels: hotels.topPicks,
      inspirations: inspirations.inspirations,
      instagram: instagram,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
